import { BenefitNotFoundError, TierNotFoundError } from "../../errors";
import validateConfig from "../validateConfig";
const isBenefitAvailableForTier = (config, tierId, benefitType) => {
    validateConfig(config);
    config = config;
    const benefitId = config.benefits.find(({ type }) => type === benefitType)?.id;
    if (!benefitId) {
        throw new BenefitNotFoundError(benefitType);
    }
    const tierConfig = config.tiers.find(({ id }) => id === tierId);
    if (!tierConfig) {
        throw new TierNotFoundError(tierId);
    }
    return tierConfig.cumulativeBenefitIds.includes(benefitId);
};
export default isBenefitAvailableForTier;
